import { Directive, ElementRef, Host, Input, OnInit, Optional } from '@angular/core';
import { TimeoutService } from '@df/ng/timeout.service';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { getClosestModal, ModalService } from '@df/ui/modal/modal.service';

/**
 * Button that will close the current modal.
 */
@Directive({
    selector: 'modal-close, [modalClose]',
    exportAs: 'modalClose',
    host: {
        '(click)': 'modalRef.close()',
        '[attr.aria-label]': 'ariaLabel || null',
        type: 'button' // Prevents accidental form submits.
    },
    standalone: true
})
export class ModalCloseDirective implements OnInit {
    /** Screenreader label for the button. */
    @Input('aria-label')
    ariaLabel?: string;

    constructor(
        @Optional() @Host() public modalRef: ModalRef<any>,
        protected elementRef: ElementRef<HTMLElement>,
        protected modalService: ModalService,
        private timeoutService: TimeoutService
    ) {}

    ngOnInit() {
        if (!this.modalRef) {
            // When this directive is included in a modal via TemplateRef (rather than being
            // in a Component), the ModalRef isn't available via injection because embedded
            // views cannot be given a custom injector. Instead, we look up the ModalRef by
            // ID. This must occur in `AfterViewInit`, as the ID binding for the modal container won't
            // be resolved at constructor time.
            this.timeoutService.setTimeout(() => {
                // tslint:disable-next-line: no-non-null-assertion
                this.modalRef = getClosestModal(this.elementRef, this.modalService.openModals)!;
            }, 10);
        }
    }
}
